import { LftLink } from '@lift/design-system-react-web/dist/components';
import { useCallback, useMemo } from 'react';
import { useAutenticacao } from '../../hooks/autenticacao/autenticacao.hook';
import { ConfigsManager } from '../../infra/configs/configs.manager';
import { removeCookie } from '../../utils/cookie/remove-cookie';
import { handleSearchParams } from '../../utils/handle-search-params/handle-search-params';
import S from './logout.styles';

export const Logout = () => {
  const dataFactory = useMemo(() => handleSearchParams, []);
  const { signOut } = useAutenticacao({
    dataFactory,
  });

  const { isEnabled } = ConfigsManager.getInstance();
  const enabledManterSessaoExperimenteAtivaApp = isEnabled('FF_MANTER_SESSAO_EXPERIMENTE_ATIVA_APP');

  const signOutHandle = useCallback(() => {
    signOut();
    localStorage.removeItem('login_hint');
    localStorage.removeItem('as');
    removeCookie('userInfo');

    if (enabledManterSessaoExperimenteAtivaApp && window.ReactNativeWebView) {
      window.ReactNativeWebView.postMessage(
        JSON.stringify({
          method: 'removeLastVisitedUrl',
        }),
      );
    }
  }, [signOut, enabledManterSessaoExperimenteAtivaApp]);

  return (
    <S.LogoutWrapper data-testid="signout">
      <LftLink label="Sair" lftClick={signOutHandle} tabIndex={0} />
    </S.LogoutWrapper>
  );
};
